import React, {FC} from 'react';
import { ButtonClassNames, TButtonFormField } from '../../types/button.types';

// NOTE: onButtonClick is not a submit handler;
// it signals to the parent form which button invoked the submit action
// (which is important for multi-step forms where multiple submits can occur i.e. back/forward)

const Button: FC<TButtonFormField> = ({ field, onButtonClick }) => {
    const {model} = field;
    const navigationStep = model.navigationStep;
    let extraClassName = 'sitecore-jss-form__button';
    if (navigationStep === -1) {
      extraClassName = extraClassName + ' ' + ButtonClassNames['Previous'];
    } else if (navigationStep === 1) {
      extraClassName = extraClassName + ' ' + ButtonClassNames['Next'] ;
    } else if (navigationStep === 0) {
      extraClassName = extraClassName + ' ' + ButtonClassNames['Submit'];
    }

    return (
        <button
          type="submit"
          className={`${field.model.cssClass} ${extraClassName}`}
          value={field.model.title}
          name={field.buttonField.name}
          id={field.buttonField.id}
          onClick={() => onButtonClick(field.buttonField.name)}
        >
          {field.model.title}
        </button>
      );
}


export default Button;